module.exports = __webpack_public_path__ + "img/doc.df555669.png";